// extracted by mini-css-extract-plugin
export default {"description_class":"Card_description_class__A0EOL"};